<template>
  <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="sign-loading-block d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex flex-column justify-content-start w-100">
<!--          <p class="sign-loading-title p font-weight-bold">Մուտքագրեք Ձեր հեռախոսահամարը</p>-->
          <p class="sign-loading-text p small">Խնդրում ենք ծանուցում ստանալուց հետո ձեր բջջային սարքում մուտքաագրեք mID PIN կոդը</p>
        </div>
        <div class="d-flex mt-4 justify-content-center w-100">
          <div slot="spinner" class="text-big text-primary spinner-border spinner-border-lg m-2" role="status"></div>
        </div>
        <div class="d-flex flex-column justify-content-start w-100">
          <p class="p mt-4">Նույնականացումը կարող եք նորից փորձել <span class="font-weight-bold">{{ timerCount }}</span> վայրկյանից</p>
        </div>
      </div>
  </div>

</template>

<script>
import purchaseTypesLongNamesCased from '@/mixins/purchaseTypes'

export default {
    name: 'contract_draft_product',
    mixins: [purchaseTypesLongNamesCased],
    props: ['handleLoaded', 'tender', 'order'],
    emits: ['validPhone', 'timeEnded'],
    data() {
        return {
          timerCount: 120,
          phoneNumber: '',
          isWithVat: false,
          isInvalidPhone: false,
          tenderData: {},
          buyer: {},
          seller: {},
          bindProps: {
            defaultCountry : "AM",
            autoDefaultCountry: false,
            dropdownOptions: {
              showDialCodeInList: true,
              showFlags: true,
              showDialCodeInSelection: true
            },
          },
        }
    },
    watch: {
      timerCount: {
        handler(value) {
          if (value > 0) {
            setTimeout(() => {
              this.timerCount--;
            }, 1000);
          } else {
            this.$emit('timeEnded')
          }
        },
        immediate: true // This ensures the watcher is triggered upon creation
      }
    },
    async mounted() {

    },
    computed: {
        me() {
            return this.$store.getters['user/me']
        },
    },
    methods: {
      validatePhone (item) {
        const valid = item.valid;
        if (valid !== undefined){
          if(!item.valid){
            this.isInvalidPhone = true;
          }
          else{
            this.isInvalidPhone = false;
          }
          this.$emit('validPhone', this.isInvalidPhone)
        }
      },

    },
}
</script>
<style>
.sign-loading-block{
  width: 380px;
}
.sign-loading-title{
  font-size: 18px;
}
.sign-loading-text{
  margin-top: 16px;
  font-size: 12px;
}
.option-box *{
    color: grey;
}
.option-box-selected *{
    color: red;
}
</style>
<style scoped>
    *{font-family: GHEA grapalat  !important;}
</style>
